const isSdvorDomain = /(?:^|\.)sdvor\.com$/.test(window.location.hostname);

export const DOMAIN_URL = isSdvorDomain
  ? import.meta.env.VITE_SDVOR_DOMAIN_URL
  : import.meta.env.VITE_ITLABS_DOMAIN_URL;
export const API_VERSION = 0;
export const API_URL = `${DOMAIN_URL}/api/${API_VERSION}`;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const YANDEX_COUNTER_ID = import.meta.env.VITE_YANDEX_COUNTER_ID;
export const isProduction = import.meta.VITE_NODE_ENV === 'production';
